export const restUrls = {
  loadUserProfile: '/me/whoami',
  saveUserProfile: '/account',
  loadTranslations: '/translations',
  reservationBundleChangeStatus: '/reservation_bundles/change_status',
  // Tasks & Annotations
  usersList: '/users/list_users_access_hotel',
  cscUsersList: '/users/customer_success_consultant_list',
  tasksTodoCount: '/tasks/todoCount',
  tasksList: '/tasks',
  markTaskAsDone: '/tasks/mark_as_done',
  assignTaskToUser: '/tasks/assign',
  changeDueDate: '/tasks/change_due_date',
  projectsList: '/projects',
  tasksSaveProject: '/projects/save_project',
  tasksCommentsList: '/tasks/list_comments',
  taskSaveComment: '/tasks/save_comment',
  taskRemove: '/tasks/remove',
  taskRemoveComment: '/tasks/remove_comment',
  tasksDeleteProject: '/projects/delete',
  annotationsList: '/annotations',
  annotationsRemove: '/annotations/remove',
  annotationsCommentsList: '/annotations/list_comments',
  annotationsSaveComment: '/annotations/save_comment',
  annotationRemoveComment: '/annotations/remove_comment',
}

// Tasks & Annotations domain constants
export const taskDueDateStatusColours = {
  OVERDUE: '#D55244',
  DUE_TODAY: '#F39652',
  DUE_TOMORROW: '#DCA311',
  DUE_CURRENT_WEEK: '#AB7B4A',
  DUE_NEXT_WEEK: '#D5986C',
}

export const taskDueDateStatus = {
  OVERDUE: 'OVERDUE',
  DUE_TODAY: 'DUE_TODAY',
  DUE_TOMORROW: 'DUE_TOMORROW',
  DUE_CURRENT_WEEK: 'DUE_CURRENT_WEEK',
  DUE_NEXT_WEEK: 'DUE_NEXT_WEEK',
}

export const tasksPriorities = [
  {label: 'Low', value: 'LOW',},
  {label: 'Medium', value: 'MEDIUM',},
  {label: 'High', value: 'HIGH',},
  {label: 'Urgent', value: 'URGENT',},
];

export const tasksStatus = [
  {label: 'Any', value: '',},
  {label: 'Todo', value: 'TODO',},
  {label: 'Done', value: 'DONE',},
];

export const visibilityFilters = [
  {label: 'All', value: '',},
  {label: 'Hotel', value: 'HOTEL',},
  {label: 'USG', value: 'USG',},
  {label: 'Reseller', value: 'RESELLER',}
];

export const taskPriorityColours = {
  LOW_BG: '#B7E6AC',
  LOW_TEXT: '#4A8A3B',
  MEDIUM_BG: '#FFECC8',
  MEDIUM_TEXT: '#DCA311',
  HIGH_BG: '#F8D5BC',
  HIGH_TEXT: '#AF5413',
  URGENT_BG: '#F2DEDD',
  URGENT_TEXT: '#D55244',
}

export const taskStatus = {
  TODO: 'TODO',
  DONE: 'DONE',
  DELETED: 'DELETED',
};

export const taskPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
};

export const reservationBundleDecision = {
  ACCEPT: 'ACCEPT',
  DECLINE: 'DECLINE',
}

export const upgradeBidRejectionReasons = [
  {
    label: 'No Room Type Availability',
    value: 'NO_ROOM_TYPE_AVAILABILITY',
  },
  {
    label: 'Limited Room Type Availability',
    value: 'LIMITED_ROOM_TYPE_AVAILABILITY',
  },
  {
    label: 'Offer too weak for current occupancy',
    value: 'OFFER_TOO_WEAK',
  },
  {
    label: "Guest can't be upgraded to different room type",
    value: 'GUEST_CANT_BE_UPGRADED',
  },
  {
    label: 'Payment was not received',
    value: 'PAYMENT_NOT_RECEIVED',
  },
]

export const bookedExtraStatus = {
  CONFIRMED: 'CONFIRMED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
}

export const roomUpgradesStatus = {
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  REPLACED: 'REPLACED',
}

export const upgradeBidsStatus = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING',
}

export const programs = {
  A: 'PRE_ARRIVAL',
  B: 'ON_ARRIVAL',
  C: 'IN_STAY'
}

export const touchpoints = {
  RESERVATION_CONFIRMATION: 'RESERVATION_CONFIRMATION',
  PRE_ARRIVAL_UPSELLING: 'PRE_ARRIVAL_UPSELLING',
  PRE_ARRIVAL_UPSELLING_REMINDER: 'PRE_ARRIVAL_UPSELLING_REMINDER',
  AT_RESERVATION: 'AT_RESERVATION',
  REGISTRATION_CARD: 'REGISTRATION_CARD',
  FRONT_DESK: 'FRONT_DESK',
  SPA: 'SPA',
  F_AND_B: 'F_AND_B',
  INHOUSE_EXTRAS: 'INHOUSE_EXTRAS',
  HOTEL_DIRECTORY: 'HOTEL_DIRECTORY',
}

export const programBTouchpoints = [
  touchpoints.FRONT_DESK,
  touchpoints.F_AND_B,
  touchpoints.SPA,
  touchpoints.AT_RESERVATION,
]

export const transactionsStatus = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  EXPIRED: 'EXPIRED',
  REPLACED: 'REPLACED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  BYPASSED: 'BYPASSED',
}

export const roomAvailabilityCapturePoint = {
  AT_CREATION: 'AT_CREATION',
  AT_DECISION: 'AT_DECISION',
  AT_CHECKIN: 'AT_CHECKIN',
  AT_CHECKOUT: 'AT_CHECKOUT',
  CURRENT: 'CURRENT',
  AT_CREATION_FROM: 'AT_CREATION_FROM',
  AT_DECISION_FROM: 'AT_DECISION_FROM',
}

export const dataLoadingStatus = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error',
}

export const HOTEL_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  ONBOARDING: 'ONBOARDING',
  TERMINATED: 'TERMINATED',
}

export const userRoles = {
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  USER: 'USER',
  ADMIN: 'ADMIN',
  TRAINER: 'TRAINER',
  TRANSLATOR: 'TRANSLATOR',
  SYSTEM: 'SYSTEM',
  RESELLER: 'RESELLER',
  USG_EMPLOYEE_SALES: 'USG_EMPLOYEE_SALES',
}

export const featureFlagPublicReleaseStages = ['PUBLIC_RESTRICTED', 'PUBLIC_OPEN']

export const featureFlagsCodes = {
  ALTERNATIVE_UPGRADES: 'ALTERNATIVE_UPGRADES',
  BIDS_AUTOPILOT: 'BIDS_AUTOPILOT',
  ROOM_UPGRADES_FIXED_PRICES: 'ROOM_UPGRADES_FIXED_PRICES',
  ROOM_UPGRADES_FIXED_PRICES_INSTANT_CONFIRMATION: 'ROOM_UPGRADES_FIXED_PRICES_INSTANT_CONFIRMATION',
  EMAIL_TEMPLATE_GALLERY: 'EMAIL_TEMPLATE_GALLERY',
  EMAIL_TEMPLATE_EXPERIMENT: 'EMAIL_TEMPLATE_EXPERIMENT',
  MANUALLY_SELECTED_EXTRAS: 'MANUALLY_SELECTED_EXTRAS',
  SEND_REQUESTS_MANUALLY: 'SEND_REQUESTS_MANUALLY',
  NO_ROOM_TYPE_NOT_MAPPED_EMAIL: 'NO_ROOM_TYPE_NOT_MAPPED_EMAIL',
  NO_CSV_REPORT_RECEIPT_CHECK: 'NO_CSV_REPORT_RECEIPT_CHECK',
  CAR_RENTAL: 'CAR_RENTAL',
  GUSTAVE: 'GUSTAVE',
  GUEST_RETARGETING: 'GUEST_RETARGETING',
  HIDE_REGULAR_UPGRADE_PRICE: 'HIDE_REGULAR_UPGRADE_PRICE',
  CHANGEABLE_GUEST_PAGE_INTRODUCTIONS: 'CHANGEABLE_GUEST_PAGE_INTRODUCTIONS',
  BLOCK_ROOMS_FOR_DATES: 'BLOCK_ROOMS_FOR_DATES',
  DISABLE_REGISTRATION_CARD_UPSELLING: 'DISABLE_REGISTRATION_CARD_UPSELLING',
  INSTANT_ROOM_UPGRADE: 'INSTANT_ROOM_UPGRADE',
  RESERVATION_CONFIRMATION_SETUP: 'RESERVATION_CONFIRMATION_SETUP',
  PRE_ARRIVAL_CONCIERGE_EMAIL_SETUP: 'PRE_ARRIVAL_CONCIERGE_EMAIL_SETUP',
  POSTSTAY_EMAIL_SETUP: 'POSTSTAY_EMAIL_SETUP',
  REGISTRATION_CARD_EMAIL_DELIVERY: 'REGISTRATION_CARD_EMAIL_DELIVERY',
  RESERVATION_CONFIRMATION_DELIVERY: 'RESERVATION_CONFIRMATION_DELIVERY',
  PRE_ARRIVAL_CONCIERGE_EMAIL_DELIVERY: 'PRE_ARRIVAL_CONCIERGE_EMAIL_DELIVERY',
  PRE_ARRIVAL_UPSELLING_EMAIL_DELIVERY: 'PRE_ARRIVAL_UPSELLING_EMAIL_DELIVERY',
  PRE_ARRIVAL_UPSELLING_REMINDER_EMAIL_DELIVERY: 'PRE_ARRIVAL_UPSELLING_REMINDER_EMAIL_DELIVERY',
  POSTSTAY_EMAIL_DELIVERY: 'POSTSTAY_EMAIL_DELIVERY',
  MOBILE_MESSAGE_DELIVERY: 'MOBILE_MESSAGE_DELIVERY',
  MOBILE_MESSAGES: 'MOBILE_MESSAGES',
  DISABLE_ROOM_UPGRADE_NOTIFICATION_EMAIL_DELIVERY: 'DISABLE_ROOM_UPGRADE_NOTIFICATION_EMAIL_DELIVERY',
  DISABLE_BOOKED_EXTRA_NOTIFICATION_EMAIL_DELIVERY: 'DISABLE_BOOKED_EXTRA_NOTIFICATION_EMAIL_DELIVERY',
  INHOUSE_MESSAGE_SETUP: 'INHOUSE_MESSAGE_SETUP',
  FIRST_INHOUSE_MESSAGE_DELIVERY: 'FIRST_INHOUSE_MESSAGE_DELIVERY',
  SECOND_INHOUSE_MESSAGE_DELIVERY: 'SECOND_INHOUSE_MESSAGE_DELIVERY',
  THIRD_INHOUSE_MESSAGE_DELIVERY: 'THIRD_INHOUSE_MESSAGE_DELIVERY',
  INHOUSE_RESERVATION_SEARCH: 'INHOUSE_RESERVATION_SEARCH',
  HOTEL_DIRECTORY: 'HOTEL_DIRECTORY',
  HOTEL_DIRECTORY_VOICE_AGENT: 'HOTEL_DIRECTORY_VOICE_AGENT',
  REGISTRATION_CARD: 'REGISTRATION_CARD',
  STORE_REGISTRATION_CARDS: 'STORE_REGISTRATION_CARDS',
  REGISTRATION_CARD_KEYCARD: 'REGISTRATION_CARD_KEYCARD',
  SHOW_CONTACT_DETAILS_GUESTS_PROFILES: 'SHOW_CONTACT_DETAILS_GUESTS_PROFILES',
  RESERVATION_CANCELLATION_SETUP: 'RESERVATION_CANCELLATION_SETUP',
  RESERVATION_CANCELLATION_DELIVERY: 'RESERVATION_CANCELLATION_DELIVERY',
  CALCULATE_AVAILABILITY_FROM_RESERVATIONS: 'CALCULATE_AVAILABILITY_FROM_RESERVATIONS',
  VERIFY_ROOM_AVAILABILITY: 'VERIFY_ROOM_AVAILABILITY',
  ROOM_UPGRADE_DYNAMIC_PRICING: 'ROOM_UPGRADE_DYNAMIC_PRICING',
  ROOM_UPGRADE_ENHANCED_DYNAMIC_PRICING: 'ROOM_UPGRADE_ENHANCED_DYNAMIC_PRICING',
  YIELD_MINIMUM_ROOM_UPGRADE_PRICE: 'YIELD_MINIMUM_ROOM_UPGRADE_PRICE',
  HIDE_GUEST_PAGES_SAME_DAY_ARRIVALS: 'HIDE_GUEST_PAGES_SAME_DAY_ARRIVALS',
  SECURITY_2FA_CHALLENGE: 'SECURITY_2FA_CHALLENGE',
  REALTIME_ROOM_UPGRADE_BIDS_AUTOPILOT: 'REALTIME_ROOM_UPGRADE_BIDS_AUTOPILOT',
  UPSELL_WITH_CURRENT_RESERVATION_ROOM_TYPE: 'UPSELL_WITH_CURRENT_RESERVATION_ROOM_TYPE',
  HIGHLIGHT_MOST_POPULAR_ROOM_UPGRADES: 'HIGHLIGHT_MOST_POPULAR_ROOM_UPGRADES',
  MANUAL_EXTRA_DISPLAY_SEQUENCE: 'MANUAL_EXTRA_DISPLAY_SEQUENCE',
  TRACK_CONFIRMATION_NUMBER: 'TRACK_CONFIRMATION_NUMBER',
  GUSTAVE_ALLOW_TWO_WAYS_INTEGRATIONS: 'GUSTAVE_ALLOW_TWO_WAYS_INTEGRATIONS',
  GUSTAVE_DISABLE_ROOM_UPGRADE_PRICE_EDIT: 'GUSTAVE_DISABLE_ROOM_UPGRADE_PRICE_EDIT',
  GUSTAVE_FLEXIBLE_UPGRADE_PRICING: 'GUSTAVE_FLEXIBLE_UPGRADE_PRICING',
  GUSTAVE_RESERVATIONS_DEPARTMENT: 'GUSTAVE_RESERVATIONS_DEPARTMENT',
  GUSTAVE_SHOW_ROOM_TYPE_COMPARISON: 'GUSTAVE_SHOW_ROOM_TYPE_COMPARISON',
  GUSTAVE_HIDE_DASHBOARD_LEADERBOARDS: 'GUSTAVE_HIDE_DASHBOARD_LEADERBOARDS',
  GUSTAVE_HIDE_PROCEED_WITHOUT_RESERVATION: 'GUSTAVE_HIDE_PROCEED_WITHOUT_RESERVATION',
  GUSTAVE_COMPETITIONS: 'GUSTAVE_COMPETITIONS',
  GUSTAVE_INFLUENCER_DASHBOARD: 'GUSTAVE_INFLUENCER_DASHBOARD',
  GUSTAVE_TRANSACTION_ATTACHMENTS: 'GUSTAVE_TRANSACTION_ATTACHMENTS',
  EXTERNAL_PAYMENT_GATEWAY: 'EXTERNAL_PAYMENT_GATEWAY',
  EXTERNAL_PRE_REGISTRATION: 'EXTERNAL_PRE_REGISTRATION',
  USER_PROFILE_PICTURE: 'USER_PROFILE_PICTURE',
  EXTERNAL_SURVEY: 'EXTERNAL_SURVEY',
  SENIOR_LEADERSHIP_REPORT: 'SENIOR_LEADERSHIP_REPORT',
  WHATSAPP: 'WHATSAPP',
  TASKS: 'TASKS',
  SMS: 'SMS',
  PRODUCT_LITE: 'PRODUCT_LITE',
  CROSS_PROPERTY_ROOM_UPGRADES: 'CROSS_PROPERTY_ROOM_UPGRADES',
  CREATE_TASKS_FROM_ALERTS: 'CREATE_TASKS_FROM_ALERTS',
  SEND_RESERVATION_DATES_CHANGED_NOTIFICATION: 'SEND_RESERVATION_DATES_CHANGED_NOTIFICATION',
  SHOW_ROOM_TYPE_ANALYSIS: 'SHOW_ROOM_TYPE_ANALYSIS',
  IMPROVE_ROOM_TYPE_DESCRIPTION: 'IMPROVE_ROOM_TYPE_DESCRIPTION',
  SHOW_COACHING_TIPS: 'SHOW_COACHING_TIPS',
  SHOW_FLASHCARDS: 'SHOW_FLASHCARDS',
  ON_ARRIVAL_CONFIRMATION_EMAIL: 'ON_ARRIVAL_CONFIRMATION_EMAIL',
  UPGRADE_OFFER_CONFIRMATION_DELIVERY: 'UPGRADE_OFFER_CONFIRMATION_DELIVERY',
  BOOKED_EXTRAS_CONFIRMATION_DELIVERY: 'BOOKED_EXTRAS_CONFIRMATION_DELIVERY',
  UPGRADE_ACCEPTED_DELIVERY: 'UPGRADE_ACCEPTED_DELIVERY',
  UPGRADE_DENIED_DELIVERY: 'UPGRADE_DENIED_DELIVERY',
  ALTERNATIVE_UPGRADE_DELIVERY: 'ALTERNATIVE_UPGRADE_DELIVERY',
  ON_ARRIVAL_CONFIRMATION_DELIVERY: 'ON_ARRIVAL_CONFIRMATION_DELIVERY',
  PRE_ARRIVAL_PAYMENT_REQUIRED: 'PRE_ARRIVAL_PAYMENT_REQUIRED',
  REQUIRE_UPGRADE_BID_REJECTION_REASON: 'REQUIRE_UPGRADE_BID_REJECTION_REASON',
  AI_INSIGHTS: 'AI_INSIGHTS',
}
